import { render, staticRenderFns } from "./swiper-news-home.vue?vue&type=template&id=321ba97b&scoped=true"
import script from "./swiper-news-home.vue?vue&type=script&lang=js"
export * from "./swiper-news-home.vue?vue&type=script&lang=js"
import style0 from "./swiper-news-home.vue?vue&type=style&index=0&id=321ba97b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321ba97b",
  null
  
)

export default component.exports